import React from 'react';
import { Link } from 'react-router-dom';

const baseUrl = process.env.PUBLIC_URL;

function StaticNavBar() {
  return (
    <div className="topbar">
      <div className="top-bar-component-container">
        <nav className="navbar navbar-expand navbar-light pt-0 pb-0">
          <Link className="navbar-brand" to={`${baseUrl}/dashboard`}>
            <img
              className="elfoLogo"
              alt="background-vector"
              src={require('../../assets/elfo_A2P.png')}
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
        </nav>
      </div>
    </div>
  );
}

export default StaticNavBar;
